import { render, staticRenderFns } from "./clinic_role_form.vue?vue&type=template&id=726ca116&scoped=true&"
import script from "./clinic_role_form.vue?vue&type=script&lang=js&"
export * from "./clinic_role_form.vue?vue&type=script&lang=js&"
import style0 from "./clinic_role_form.vue?vue&type=style&index=0&id=726ca116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726ca116",
  null
  
)

export default component.exports